import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501227ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center mb-3" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = ["disabled", "value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "ms-2 fs-8 text" }

import { useRouter, useRoute } from 'vue-router'
import { PropType } from 'vue'
import { translate } from '@/languages/i18n'

export type optionItem = {
  value: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  options: {
    type: Array as PropType<Array<optionItem>>,
    required: true,
  },
  keyName: {
    type: String,
    required: true,
  },
  isNotFilterUrl: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  pageOfNumber: {
    type: Number,
  },
},
  emits: ['changeQuery'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
const route = useRoute()


const handleSelectOption = (e) => {
  let query = { ...route?.query, [props.keyName]: e.target.value, page: 1 }
  emit('changeQuery', query)
  if (props.isNotFilterUrl) {
    return
  }
  router.push({ path: route.path, query: query })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        disabled: __props.disabled,
        class: "form-select form-select-custom",
        "aria-label": ".form-select",
        onChange: handleSelectOption,
        value: _unref(route)?.query[__props.keyName] || __props.pageOfNumber || __props.options[0].value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: option.value
          }, _toDisplayString(option.label), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)('CC10display')), 1)
  ]))
}
}

})